class Registry {
    constructor() {
        this.objects = {};
    }

    add(key, value) {
        if (typeof key == 'object' && typeof value == 'undefined') {
            for (var index in key) {
                this._add(index, key[index]);
            }
        } else if (typeof key == 'string' && value) {
            this._add(key, value);
        } else {
            throw Error('Cannot add object to Registry, key or value is missing.');
        }
    }

    _add(key, value) {
        if (typeof this.objects[key] != 'undefined') {
            throw Error('Registry object with this key is already set.');
        }

        this.objects[key] = value;
    }

    get(key, strict = true) {
        if (typeof this.objects[key] == 'undefined') {
            if (strict) throw Error('Registry object with this key is not set.');
        }

        return this.objects[key];
    }
}

let _instance;

/**
 * @return {Registry}
 */
function getInstance() {
    if (!_instance) {
        _instance = new Registry();
    }

    return _instance;
}

export default getInstance();


// WEBPACK FOOTER //
// ./local_modules/registry/index.js